import { useQuery } from '@tanstack/react-query';
import useLocalStorage from './useLocalStorage';
import { Pose, } from '../models';
import QueryKeys from '../utils/QueryKeys';

export default function useMultiSeasonPoses(studentId, packageId) {
  const [currentSeason] = useLocalStorage(`currentSeason-${studentId}`);

  return useQuery([QueryKeys.STUDENT_IMAGES, studentId, packageId, false, currentSeason, 'multiSeason'], () => {
    return Pose
      .selectExtra(['folder'])
      .where({ forPackage: [packageId, studentId, currentSeason] }).all()
      .then((res) => {
        if (!res.data) return [];

        return res.data;
      });
  }, { placeholderData: [], enabled: !!(studentId && packageId) });
}
